export enum AlertTypes {
    SUCCESS = 1,
    ERROR = 2,
    WARNING = 3,
    INFO = 4,
}

export enum AlertColors {
    SUCCESS = "green",
    ERROR = "red",
    WARNING = "amber",
    INFO = "blue",
}